import type { DomainZone } from '../types';

export const getDomainZone = (host: string): DomainZone => {
  const [hostname] = host.split(':');
  const parts = hostname.split('.');
  const topLevelDomain = parts[parts.length - 1];

  return topLevelDomain === 'com' ? 'com' : 'ru';
};
